import { useState, useEffect }          from 'react';
import Textfield                        from 'app/common/uikit/textfield';
import Checkbox                         from 'app/common/uikit/checkbox';
import { useSelector, shallowEqual }    from "react-redux";
import { useSendInvoiceEmail }          from 'app/services/query';

const SendMail = props => {
    const p                         = props;
    const r 			            = useSelector(state => ({
        accessToken         : state.provider.accessToken,
        invoiceData         : state.provider.invoiceData,
    }), shallowEqual);

    const [ s, setState ]           = useState({
        email               : r?.invoiceData?.earchiveInvoice?.eMailAddress || '',
        useCurrentEmail     : true
    });

    const emailHandler              = useSendInvoiceEmail();

    const updateFormData = (node, value) => {
        setState(prevState => ({
            ...prevState,
            [node]: value
        }))
    }

    const sendEmail = () => {
        if (s.email.length)
            emailHandler.mutate({
                data: {
                    invoiceUUID     : r.invoiceData.earchiveInvoice.invoiceUUID,
                    eMailAddress    : s.email,
                    isDraft         : false,
                    eMailType       : 'Standart'
                },
                accessToken: r.accessToken
            })
    }

    const changeCurrentEmailStatus = status => {
        setState(prevState => ({
            email               : status ? r.invoiceData.earchiveInvoice.eMailAddress : '',
            useCurrentEmail     : status
        }))
    }

    useEffect(() => {
        if (emailHandler.isSuccess)
            p.closeModal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ emailHandler.isSuccess ])

    return (
        <div className="modal-wrapper">
            <div className="modal">
                <div className="modal-header">
                    <div className="title">E-Posta Gönder</div>
                    <div className="close" onClick={ () => p.closeModal() }><div className="icon flat close"></div></div>
                </div>
                <div className="modal-content">
                    <Textfield
                        attrs       = {{
                            id: 'email',
                            name: 'email',
                            tabIndex: 1,
                            disabled:  s.useCurrentEmail
                        }}
                        label       = { 'E-Posta' }
                        onChange    = { value => updateFormData('email', value )}
                        value       = { s.email }
                        fieldName   = { 'email' }
                        errors      = { [] }
                    />   
                    <div className="cb-container">
                        <Checkbox
                            label   = { 'Belge içindeki e-posta adresini kullan' }
                            checked = { s.useCurrentEmail }
                            attrs   = {{
                                name    : 'useCurrent',
                                id    : 'useCurrent',
                            }}
                            onChange= { value => changeCurrentEmailStatus(value ) }
                        />
                    </div>              
                </div>
                <div className="modal-footer">
                    <button className="button" onClick={ () => p.closeModal() }>Vazgeç</button>
                    <button className="button colored" disabled={ !s.email.length || emailHandler.isPending } onClick={ () => sendEmail() }>Gönder</button>
                </div>
            </div>
        </div>
    )
}

export default SendMail